import React from "react";
import GenerativeTestimonial from "./generativeTestimonial/GenerativeTestimonial";
import GenerativeUse from "./generativeUse/GenerativeUse";
import Services from "./generativeService/Services";
import GenerativePrinciple from "./generativeprinciple/GenerativePrinciple";
import GenerativeJourney from "./generativeJourney/GenerativeJourney";
import GenerativeEnterprise from "./generativeEnterprise/GenerativeEnterprise";
import GenerativeSolution from "./generativeSolution/GenerativeSolution";
import GenerativeServices from "./generativeservices/GenerativeServices";
import GenerativeHero from "./generativeHero/GenerativeHero";
import GenerativeTrust from "./generativeTrust/GenerativeTrust";

export default function Generative() {
  return (
    <div>
      <GenerativeHero />
      <GenerativeSolution />
      <GenerativeServices />
      <GenerativeEnterprise />
      <GenerativeJourney />
      <GenerativePrinciple />
      <GenerativeTrust />
      <GenerativeUse />
      <GenerativeTestimonial />
      <Services />
    </div>
  );
}
